"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpChannelLabelRUMap = void 0;
const _1 = require(".");
exports.OtpChannelLabelRUMap = {
    [_1.EOtpChannelTypes.sms]: 'СМС',
    [_1.EOtpChannelTypes.sim_push]: 'ПУШ/СМС'
    // [EOtpChannelTypes.incoming_wapi]: 'whatsapp',
    // [EOtpChannelTypes.viber]: 'viber',
    // [EOtpChannelTypes.voice]: 'звонок',
    // [EOtpChannelTypes.whatsapp]: 'whatsapp',
    // [EOtpChannelTypes.flashcall]: 'звонок',
    // [EOtpChannelTypes.incoming_tg_bot]: 'telegram бот'
};
//# sourceMappingURL=otp-channel-label-map.js.map